// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 7/10/2024 11:47:58 AM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

import { DiscountSourceTypeEnum } from '../schema/Schema';
import { SubscriptionPeriodAuditTypeEnum } from '../schema/Schema';
import { AlfredCompanyStatusTypeEnum } from '../schema/Schema';
import { RemittanceFrequencyTypeEnum } from '../../../appCore/models/schema/Schema';
import { SalesTaxTypeEnum } from '../schema/Schema';
import { BankAccountTypeEnum } from '../schema/Schema';
import { PartnerInvoiceItemTypeEnum } from '../schema/Schema';
import { SecurityRoleTypeEnum } from '../../../appCore/models/schema/Schema';
import { CloseAccountUiLinkTypeEnum } from '../schema/Schema';
import { WorkflowResponseInterface } from '../functions/Functions';

export enum PaymentStatusTypeEnum {
  notSpecified = 0,
  notVerified = 1,
  pendingVerification = 2,
  verified = 3,
}

export enum TrialStateTypeEnum {
  enjoying = 0,
  inProgress = 1,
  youAreIn = 2,
}

export enum CloseAccountTypeEnum {
  trialCloseIndication = 0,
  trialClosed = 1,
  nonTrialCloseIndication = 2,
}

export enum InvoiceStatusTypeEnum {
  notSpecified = 0,
  paid = 1,
  unpaid = 2,
  void = 3,
}

export enum InvoiceFeeTypeEnum {
  notSpecified = 0,
  subscription = 1,
  nsf = 2,
}

export enum InactiveTypeEnum {
  sitTight = 0,
  addPaymentInfo = 1,
  transferFunds = 2,
  closed = 3,
}

export enum ClientStatusTypeEnum {
  complete = 0,
  onboardingInProgress = 1,
  inviteSent = 2,
  closed = 3,
  onboardingNotStarted = 4,
  accountVerificationInProgress = 5,
  disconnected = 6,
  closedWithReportsAccess = 7,
  clientRequestReceived = 8,
}

export enum InactiveReasonTypeEnum {
  notInactive = 0,
  pendingVerification = 1,
  closed = 2,
  nsfLock = 3,
  trialExpired = 4,
  reactivation = 5,
}

export enum InvoiceTypeEnum {
  notSpecified = 0,
  payroll = 1,
  fee = 2,
  creditInvoice = 3,
}

export enum InvoiceSortTypeEnum {
  notSpecified = 0,
  invoiceId = 1,
  billingCycle = 2,
  invoiceAmount = 3,
  invoiceStatusType = 4,
  invoiceType = 5,
  invoiceFeeType = 6,
  companyName = 7,
  planName = 8,
  invoiceDueDate = 9,
  invoiceDiscount = 10,
}

export enum CompanySortTypeEnum {
  notSpecified = 0,
  companyName = 1,
  planName = 2,
  country = 3,
  ownerName = 4,
  billingSetup = 5,
  nextPayDate = 6,
  clientStatus = 7,
  twoStepApproval = 8,
}

export enum InvoiceItemTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  monthlyFee = 2,
  personFee = 3,
  nsfFee = 4,
  customerDiscount = 5,
  partnerDiscount = 6,
  salesTax = 7,
  billAdjustmentCharge = 8,
  billAdjustmentCredit = 9,
  taxCredit = 10,
  rejectedFee = 11,
}

export enum CompanyStatusTypeEnum {
  notSpecified = 0,
  waitingData = 1,
  pendingVerification = 2,
  active = 3,
  inactive = 4,
  closeInitiated = 5,
  closePending = 6,
  closed = 7,
  expired = 8,
}

export enum AccountStatusEnum {
  trial = 0,
  expired = 1,
  active = 2,
  suspended = 3,
  closed = 4,
  blacklisted = 5,
}

export enum CloseAccountStatusTypeEnum {
  notSpecified = 0,
  closeAllowed = 1,
  outstandBalance = 2,
  waitingFinalizedPayroll = 3,
  undoApprovedPayroll = 4,
}

export interface GetOverviewRequestInterface {
  overviewCriteria: OverviewCriteriaInterface;
}

export interface GetOverviewResponseInterface {
  overviewContainer: OverviewContainerInterface;
  validationResults: ValidationResultsInterface;
}

export interface OverviewContainerInterface {
  trialCard?: TrialCardInterface;
  planCard?: PlanCardInterface;
  paymentDetailsCard?: PaymentDetailsCardInterface;
  referralCard?: ReferralCardInterface;
  clientCurrentActivityCard?: ClientCurrentActivityCardInterface;
  expiredTrialCard?: ExpiredTrialCardInterface;
  closeAccountCard?: CloseAccountCardInterface;
  inactiveCard?: InactiveCardInterface;
  offTheHookCard?: OffTheHookCardInterface;
  partnerHandlingCard?: PartnerHandlingCardInterface;
  discountCard?: DiscountCardInterface;
  partnerChangeCard?: PartnerChangeCardInterface;
  disconnectCard?: DisconnectCardInterface;
  bankAccountCard?: BankAccountCardInterface;
  billingInfoCard?: BillingInfoCardInterface;
  partnerOverviewCard?: PartnerOverviewCardInterface;
  accountStatusCard?: AccountStatusCardInterface;
}

export interface PlanCardInterface {
  showCard: boolean;
  showCancelClose: boolean;
  showPlanOnHold: boolean;
  showPlanActive: boolean;
  showChangePlan: boolean;
  showCloseAccount: boolean;
  showTrial: boolean;
  closeAccountStatusType: CloseAccountStatusTypeEnum;
  handlingPartnerName: string;
  extendedPlanInfo?: ExtendedPlanInfoInterface;
  subscriptionPlan: SubscriptionPlanInterface;
}

export interface TrialCardInterface {
  showCard: boolean;
  trialStateType: TrialStateTypeEnum;
  trialEndsDate: string;
  showPayroll: boolean;
  showTrialIsEnding: boolean;
  subscrtiptionStartDate?: string;
  signupDate: string;
  planName: string;
  payrollCount: number;
  showPotentialDisruption: boolean;
}

export interface PaymentDetailsCardInterface {
  showCard: boolean;
  paymentStatusType: PaymentStatusTypeEnum;
}

export interface ReferralCardInterface {
  showCard: boolean;
}

export interface GetSubscriptionPlanListRequestInterface {}

export interface GetSubscriptionPlanListResponseInterface {
  subscriptionPlanList: Array<SubscriptionPlanInterface>;
  validationResults: ValidationResultsInterface;
}

export interface SubscriptionPlanInterface {
  id: number;
  name: string;
  isCurrentPlan: boolean;
  perPersonFee: number;
  baseFee: number;
  isPartnerHandling: boolean;
  featureList: Array<FeatureInterface>;
}

export interface FeatureInterface {
  id: number;
  name: string;
}

export interface ExpiredTrialCardInterface {
  showCard: boolean;
  deactivationDate: string;
}

export interface CloseAccountCardInterface {
  showCard: boolean;
  completeBy: string;
  closedAccountDate?: string;
  deactivationDate: string;
  closeAccountType: CloseAccountTypeEnum;
  closeAccountSuggestionList: Array<CloseAccountCheckInterface>;
}

export interface ClientCurrentActivityCardInterface {
  showCard: boolean;
  numberOfPeople: number;
  subTotal: number;
  discount: number;
  discountDescription: string;
  taxes: number;
  taxDescription: string;
  renewDays: number;
  nsfCount: number;
  nsfFee: number;
  rejectedCount: number;
  rejectedFee: number;
  additionalCharges: number;
  credits: number;
  invoiceContainer?: InvoiceContainerInterface;
}

export interface GetInvoiceListRequestInterface {
  invoiceCriteria: InvoiceCriteriaInterface;
}

export interface GetInvoiceListResponseInterface {
  debugLogs: string;
  invoiceContainer: InvoiceContainerInterface;
  validationResults: ValidationResultsInterface;
}

export interface CustomerInvoiceInterface {
  id: number;
  billingStart: string;
  billingEnd: string;
  amount: number;
  dueOn: string;
  planName: string;
  invoiceStatusType: InvoiceStatusTypeEnum;
  invoiceType: InvoiceTypeEnum;
  invoiceFeeType: InvoiceFeeTypeEnum;
  perPersonFee: number;
  baseFee: number;
  billFrom: string;
  billTo: string;
  invoiceDate: string;
  invoiceItemList: Array<InvoiceItemInterface>;
}

export interface InvoiceCriteriaInterface {
  companyId?: number;
  partnerId?: number;
  invoiceId?: number;
  subscriptionPlanId?: number;
  skip: number;
  take: number;
  yearList?: Array<number>;
  monthList?: Array<number>;
  invoiceType: InvoiceTypeEnum;
  invoiceStatusType: Array<InvoiceStatusTypeEnum>;
  invoiceFeeType: Array<InvoiceFeeTypeEnum>;
  invoiceSortType: InvoiceSortTypeEnum;
  getCustomerInvoices: boolean;
  getPartnerInvoiceSummary: boolean;
  getPartnerInvoices: boolean;
  getPartnerBarTabs: boolean;
  fromDate?: string;
  toDate?: string;
  sortDescending: boolean;
}

export interface InvoiceItemInterface {
  id: number;
  description: string;
  amount: number;
  memo: string;
  invoiceItemType: InvoiceItemTypeEnum;
  initialAmount: number;
  discountAmount: number;
  discountPercent: number;
  planName: string;
  nsfDate?: string;
  proratedDateFrom?: string;
  proratedDateTo?: string;
  peopleCount?: number;
  rejectedDate?: string;
  rejectedPersonName: string;
  rejectedTaxAgency: string;
  salesTaxPercent?: number;
  perPersonPlanFee?: number;
  proratedCoefficient?: number;
  proratedDayCount?: number;
  discountSourceType: DiscountSourceTypeEnum;
}

export interface PlanSelectedCardInterface {
  accessCurrentUntil: string;
  planChangeOn: string;
  showAccessUntil: boolean;
  showPlanChange: boolean;
  showProRate: boolean;
  reviewPlanList: Array<ReviewPlanInterface>;
}

export interface ReviewPlanInterface {
  planId: number;
  planName: string;
  baseFee: number;
  perPersonFee: number;
  isCurrent: boolean;
  isSelected: boolean;
}

export interface InactiveCardInterface {
  showCard: boolean;
  showOweMoney: boolean;
  amountToBeTransferred: number;
  fee: number;
  inactiveType: InactiveTypeEnum;
  inactiveReasonType: InactiveReasonTypeEnum;
  incomingPaymentList: Array<IncomingPaymentInterface>;
}

export interface IncomingPaymentInterface {
  id: number;
  type: string;
  documentId?: number;
  transferDate: string;
  transferAmount: number;
  hasBeenReceived: boolean;
}

export interface OffTheHookCardInterface {
  showCard: boolean;
  billingCycleStart: string;
  billingCycleEnd: string;
  showFirmConnectionHint: boolean;
  partnerName: string;
  partnerDateStart?: string;
  renewDays: number;
}

export interface PartnerOverviewCardInterface {
  showCard: boolean;
  subTotal: number;
  discount: number;
  discountPercent: number;
  taxes: number;
  taxDescription: string;
  total: number;
  renewDays: number;
  nextBumpPercent: number;
  thisBillingMonth: number;
  nextInvoiceDate: string;
  partnerFeeList: Array<PartnerFeeInterface>;
}

export interface PartnerFeeInterface {
  id: number;
  planName: string;
  planId: number;
  clientCount: number;
  amount: number;
}

export interface InvoiceContainerInterface {
  invoiceYears?: Array<number>;
  partnerBarTabList: Array<PartnerBarTabInterface>;
  customerInvoiceList: Array<CustomerInvoiceInterface>;
  partnerInvoiceSummaryCard?: PartnerInvoiceSummaryCardInterface;
  partnerInvoiceList: Array<PartnerInvoiceInterface>;
  partnerInvoiceItemList: Array<PartnerInvoiceItemInterface>;
  partnerNsfInvoice?: PartnerNsfInvoiceInterface;
}

export interface PartnerBarTabInterface {
  id: number;
  clientName: string;
  planName: string;
  baseFee: number;
  perPersonFee: number;
  numberOfPeople: number;
  subtotal: number;
  discounts: number;
  gstHst: number;
  pstQst: number;
  total: number;
  nsfFee: number;
}

export interface PartnerChangeCardInterface {
  showCard: boolean;
  partnerChangeList: Array<PartnerChangeInterface>;
}

export interface PartnerChangeInterface {
  clientName: string;
  planName: string;
  firmAdminName: string;
  changeDate: string;
  changeType: SubscriptionPeriodAuditTypeEnum;
}

export interface PartnerHandlingCardInterface {
  showCard: boolean;
  billingCycleStart: string;
  billingCycleEnd: string;
  partnerName: string;
  planId: number;
  planName: string;
}

export interface ExecuteActionRequestInterface {
  restore: boolean;
  refer: boolean;
  changePlan: boolean;
  closeAccount: boolean;
  reactivate: boolean;
  persistSalesTaxExemption: boolean;
  persistBillAdjustment: boolean;
  disconnectFromClient: boolean;
  transferFunds: boolean;
  changeBillingResponsibility: boolean;
  companyId: number;
  reconnectToClient: boolean;
  overviewContainer?: OverviewContainerInterface;
  persistBillAdjustmentRequest?: PersistBillAdjustmentRequestInterface;
  salesTaxExemptionContainer?: SalesTaxExemptionInterface;
  changePlanRequest?: ChangePlanRequestInterface;
  closeAccountRequest?: CloseAccountRequestInterface;
  reactivateRequest?: ReactivateRequestInterface;
  changeBillingResponsibilityRequest?: ChangeBillingResponsibilityRequestInterface;
  disconnectRequest?: DisconnectRequestInterface;
  persistSalesTaxExemptionRequest?: PersistSalesTaxExemptionRequestInterface;
  reconnectToClientRequest?: ReconnectToClientRequestInterface;
}

export interface ExecuteActionResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface DiscountCardInterface {
  showCard: boolean;
  discountPercent: number;
  clientCount: number;
  nextDiscountPercent?: number;
  currentTierNumber: number;
  nextTierNumber: number;
  numberOfClientsToNextBump: number;
  nextTierExists: boolean;
  showWhenClientSignsMessage: boolean;
  whenClientSignsMessage: string;
  prevDiscountPercent: number;
  partnerDiscountTierList: Array<PartnerDiscountTierInterface>;
}

export interface CompanyInterface {
  id: number;
  name: string;
  planId: number;
  planName: string;
  partnerPays: boolean;
  nextPayDate?: string;
  twoStepApprovalOn: boolean;
  clientStatusType: ClientStatusTypeEnum;
  securityRoleTypeId: number;
  dba: string;
  accountOwner: string;
  companyTypeFlags: number;
  companyCode: string;
  country: string;
  isFraudAlert: boolean;
  accountOwnerEmail: string;
  alfredCompanyStatusType: AlfredCompanyStatusTypeEnum;
  invitationId?: number;
  companyStatusType: CompanyStatusTypeEnum;
  connectedCompanyList: Array<CompanyInterface>;
}

export interface GetCompanyListRequestInterface {
  companyCriteria: CompanyCriteriaInterface;
}

export interface GetCompanyListResponseInterface {
  hasDisconnectedClients: boolean;
  companyList: Array<CompanyInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetCompanyOverviewRequestInterface {
  companyId: number;
  partnerId: number;
}

export interface GetCompanyOverviewResponseInterface {
  companyOverviewContainer: CompanyOverviewContainerInterface;
  validationResults: ValidationResultsInterface;
}

export interface CompanyOverviewContainerInterface {
  companyCard?: CompanyCardInterface;
  companyDetailCard?: CompanyDetailCardInterface;
  taxDetailCard?: TaxDetailCardInterface;
  companyPlanCard?: CompanyPlanCardInterface;
  permissionsCard?: PermissionsCardInterface;
  employeeTaxCard?: EmployeeTaxCardInterface;
}

export interface CompanyCardInterface {
  showCard: boolean;
  planId: number;
  planName: string;
  contactName: string;
  contactEmail: string;
  clientStatusType: ClientStatusTypeEnum;
  hasTwoStepApprovalOn: boolean;
  partnerIsTheOnlySubmitter: boolean;
}

export interface CompanyDetailCardInterface {
  showCard: boolean;
  dba: string;
  address: string;
  location: string;
  roeRegistrationSigned?: string;
}

export interface PermissionsCardInterface {
  showCard: boolean;
  securityRoleTypeId: number;
}

export interface TaxDetailCardInterface {
  showCard: boolean;
  craAccountNumber: string;
  rqAccountNumber: string;
  remittanceSchedule: string;
  remittanceFrequencyType: RemittanceFrequencyTypeEnum;
  ontarioEht?: OntarioEhtInterface;
}

export interface CompanyPlanCardInterface {
  showCard: boolean;
  planId: number;
  planName: string;
  nextBillDate?: string;
  clientPaysFees: boolean;
  clientBaseFee: number;
  clientPerPersonFee: number;
  currentBillingCycleStart?: string;
  isTrial: boolean;
}

export interface EmployeeTaxCardInterface {
  showCard: boolean;
  netPay: number;
  grossPay: number;
  deductions: number;
  taxes: number;
}

export interface PartnerInvoiceSummaryCardInterface {
  showCard: boolean;
  clientCount: number;
  partnerDiscount: number;
  totalSavings: number;
  invoiceTotal: number;
}

export interface OverviewCriteriaInterface {
  companyId?: number;
  companyCode: string;
  isPartner: boolean;
  getPartnerChangeCard: boolean;
  getDisconnectInfo: boolean;
  getExtendedPlan: boolean;
  getChameleonCards: boolean;
  getPlanCard: boolean;
  getReferralCard: boolean;
  getBankAccountCard: boolean;
  getBillingInfoCard: boolean;
  getPartnerHandlingCard: boolean;
  getDiscountCard: boolean;
}

export interface DisconnectCardInterface {
  showCard: boolean;
  clientCount: number;
  nextBillingCycleMonth?: string;
  discountPercent?: number;
  clientName?: string;
  partnerCompanyId?: number;
  clientCompanyId: number;
  disconnectDetails: DisconnectDetailsInterface;
}

export interface ExtendedPlanInfoInterface {
  billingCycleDateFrom?: string;
  billingCycleDateTo?: string;
  billTo: string;
  salesTaxDescription: string;
  defaultToClientsPayCharges: boolean;
  discount: number;
  clientCount: number;
  clientPayingCount: number;
  partnerPayingCount: number;
  nextInvoiceDate?: string;
  discountSourceType: DiscountSourceTypeEnum;
  defaultPartnerDiscount?: number;
  salesTaxExemptionList: Array<SalesTaxExemptionInterface>;
}

export interface GetSubscriptionHistoryRequestInterface {
  subscriptionHistoryCriteria: SubscriptionHistoryCriteriaInterface;
}

export interface GetSubscriptionHistoryResponseInterface {
  subscriptionHistoryList: Array<SubscriptionHistoryInterface>;
  validationResults: ValidationResultsInterface;
}

export interface SubscriptionHistoryInterface {
  id: number;
  historyDate: string;
  amount: number;
  description: string;
  details: string;
}

export interface SubscriptionHistoryCriteriaInterface {
  companyId: number;
  skip: number;
  take: number;
  fromDate?: string;
  toDate?: string;
  invoiceSortType: InvoiceSortTypeEnum;
  sortDescending: boolean;
}

export interface SalesTaxExemptionInterface {
  id: number;
  salesTaxType: SalesTaxTypeEnum;
  isExempt: boolean;
  effectiveFrom?: string;
  effectiveTo?: string;
  documentId?: number;
  resumedTo?: string;
  resumedFrom?: string;
}

export interface GetBillAdjustmentListRequestInterface {
  billAdjustmentCriteria: BillAdjustmentCriteriaInterface;
}

export interface GetBillAdjustmentListResponseInterface {
  billAdjustmentList: Array<BillAdjustmentInterface>;
  validationResults: ValidationResultsInterface;
}

export interface BillAdjustmentCriteriaInterface {
  companyId: number;
  skip: number;
  take: number;
  getDetail: boolean;
  billAdjustmentId?: number;
  filterOnType: boolean;
  filterOnDateCreated: boolean;
  filteredTypeCredit?: boolean;
  filteredTypeDebit?: boolean;
  filteredDateCreatedFrom?: string;
  filteredDateCreatedTo?: string;
  search: string;
}

export interface BillAdjustmentInterface {
  id: number;
  companyId?: number;
  dateCreated: string;
  amount: number;
  memo: string;
  internalNotes: string;
  isCharge: boolean;
  isCredit: boolean;
  canBeEdited?: boolean;
  outstanding?: number;
  canBeRemoved?: boolean;
  billAdjustmentHistoryList: Array<BillAdjustmentHistoryInterface>;
}

export interface BillAdjustmentHistoryInterface {
  id: number;
  appliedDate: string;
  amount: number;
  invoiceId: number;
}

export interface SalesTaxExemptionContainerInterface {
  salesTaxExemptionList: Array<SalesTaxExemptionInterface>;
}

export interface BankAccountCardInterface {
  showCard: boolean;
  bankAccountType: BankAccountTypeEnum;
  accountNumber: string;
  padConfirmationDate?: string;
  bank: string;
  transit: string;
  verifiedDate?: string;
}

export interface BillingInfoCardInterface {
  showCard: boolean;
  companyName: string;
  billingAddress: string;
  emailAddress: string;
}

export interface OntarioEhtInterface {
  showSection: boolean;
  thresholdAmount: number;
  grossPayrollToDate: number;
}

export interface PartnerDiscountTierInterface {
  id: number;
  percent: number;
  clientCountFrom: number;
  clientCountTo: number;
}

export interface PartnerInvoiceInterface {
  id: number;
  billingStart: string;
  billingEnd: string;
  amount: number;
  dueDate: string;
  paidOn?: string;
  isClientNsf: boolean;
  invoiceStatusType: InvoiceStatusTypeEnum;
  invoiceType: InvoiceTypeEnum;
  invoiceFeeType: InvoiceFeeTypeEnum;
  discount: number;
  invoiceDate: string;
  billFrom: string;
  billTo: string;
  partnerInvoiceItemList: Array<PartnerInvoiceItemInterface>;
}

export interface PartnerInvoiceItemInterface {
  id: number;
  clientName: string;
  planName: string;
  baseFee: number;
  perPersonFee: number;
  numberOfPeople: number;
  subtotal: number;
  discounts: number;
  gstHst: number;
  pstQst: number;
  total: number;
  nsfFee: number;
  documentId: number;
  subscriptionPeriodId: number;
  personFeeInitialAmount: number;
  personFeeDiscountAmount: number;
  discountPercent: number;
  personFee?: number;
  rejectedDepositFee?: number;
  credit?: number;
  charge?: number;
  sortOrder: number;
  partnerInvoiceItemType: PartnerInvoiceItemTypeEnum;
  baseFeeInitialAmount: number;
  baseFeeDiscountAmount: number;
}

export interface CompanyCriteriaInterface {
  filterOnAdministrator: boolean;
  filterOnCountry: boolean;
  filterOnBilling: boolean;
  filterOnPermissionType: boolean;
  filterOnCompanyName: boolean;
  filterOnDisconnectedClients: boolean;
  filterOnPlan: boolean;
  filterOnPartner: boolean;
  filterOnStatus: boolean;
  filterOnMonthList: boolean;
  filterOnYearList: boolean;
  filterOnCompanyTypeFlags: boolean;
  filterOnDba?: boolean;
  filterOnCompanyCode?: boolean;
  filterOnCraNumber?: boolean;
  filterOnCompanyStatus: boolean;
  partnerId?: number;
  countryIdList?: Array<number>;
  planId?: number;
  administratorIdList?: Array<number>;
  securityRoleTypeList: Array<SecurityRoleTypeEnum>;
  startsWithCompanyName?: string;
  includeCompanyInvitationList: boolean;
  includeCompanyOwner: boolean;
  sortDescending: boolean;
  companySortType: CompanySortTypeEnum;
  monthList: Array<number>;
  yearList: Array<number>;
  companyTypeFlags: number;
  skip: number;
  take: number;
  dba?: string;
  companyCode?: string;
  craNumber?: string;
  companyStatusType: CompanyStatusTypeEnum;
  partnerPays?: boolean;
  clientPays?: boolean;
  filterOnNotClosedAndNotExpired: boolean;
}

export interface ChangePlanRequestInterface {
  changeToPlanId: number;
  optIinIfPlanIsSame: boolean;
}

export interface CloseAccountRequestInterface {
  comments: string;
  alternateProviderId?: number;
  closeAccountLeaveReasonId?: number;
  closeAccountStopReasonId?: number;
  customStopReason: string;
  customAlternateProvider: string;
  customLeavingReason: string;
  payStubsDownloaded: boolean;
  downloadedReports: boolean;
  submittedReview: boolean;
  closeAccountBringHereReasonId: number;
  closeAccountCheckList: Array<CloseAccountCheckInterface>;
}

export interface CloseAccountCheckInterface {
  id: number;
  closeAccountSuggestionId: number;
  isChecked: boolean;
  closeAccountUiLinkType: CloseAccountUiLinkTypeEnum;
}

export interface ReactivateRequestInterface {
  planId?: number;
}

export interface PersistBillAdjustmentRequestInterface {
  delete: boolean;
  billAdjustment: BillAdjustmentInterface;
}

export interface ProcessWorkflowRequestInterface {
  workflowInstanceKey: string;
  skipCustomer: boolean;
  skipPartner: boolean;
  skipTrialExpireRollover: boolean;
  skipTrialExpireClose: boolean;
  skipClose: boolean;
  skipTrialBanner: boolean;
  numberOfLoops: number;
  includeDebugLog: boolean;
  skipNsf: boolean;
  maxProcessCount?: number;
  runOneInvoice: boolean;
  oneInvoiceCompanyId?: number;
  oneInvoiceBillingCycleStart?: string;
  oneInvoiceBillingCycleEnd?: string;
}

export interface ProcessWorkflowResponseInterface {
  workflowResponse: WorkflowResponseInterface;
  debugLogs: Array<string>;
  validationResults: ValidationResultsInterface;
}

export interface GetCloseAccountDataRequestInterface {
  companyId: number;
}

export interface GetCloseAccountDataResponseInterface {
  closeAccountContainer: CloseAccountContainerInterface;
  validationResults: ValidationResultsInterface;
}

export interface CloseAccountReasonInterface {
  id: number;
  name: string;
}

export interface CloseAccountProviderInterface {
  id: number;
  name: string;
}

export interface CloseAccountContainerInterface {
  closeAccountDate?: string;
  daysToCloseAccountDate: number;
  closeAccountReasonList: Array<CloseAccountReasonInterface>;
  closeAccountProviderList: Array<CloseAccountProviderInterface>;
  closeAccountBringHereReasonList: Array<CloseAccountBringHereReasonInterface>;
  closeAccountStopReasonList: Array<CloseAccountStopReasonInterface>;
  closeAccountSuggestionList: Array<CloseAccountSuggestionInterface>;
}

export interface ChangeBillingResponsibilityRequestInterface {
  partnerIsResponsible: boolean;
  partnerCompanyId: number;
}

export interface DisconnectRequestInterface {
  partnerCompanyId: number;
}

export interface PersistSalesTaxExemptionRequestInterface {
  salesTaxExemptionContainer: SalesTaxExemptionContainerInterface;
}

export interface PartnerNsfInvoiceInterface {
  id: number;
  nsfFee: number;
  gstHst: number;
  pstQst: number;
  total: number;
  status: string;
}

export interface ReconnectToClientRequestInterface {
  isPartnerHandling: boolean;
  clientCompanyId: number;
  securityRoleTypeId: number;
}

export interface DisconnectDetailsInterface {
  clientName: string;
  planType: string;
  changeDetails?: string;
  reason: SubscriptionPeriodAuditTypeEnum;
}

export interface TestInvoiceRequestInterface {
  startDate: string;
  endDate: string;
  currentCyclePeople: number;
  state: string;
  companyName: string;
  customDiscountPercent?: number;
  testSubscriptionPeriodList: Array<TestSubscriptionPeriodInterface>;
  adjustmentList: Array<AdjustmentInterface>;
  testNsfActivityList: Array<TestNsfActivityInterface>;
  testRejectedActivityList: Array<TestRejectedActivityInterface>;
}

export interface TestSubscriptionPlanInterface {
  monthlyFee: number;
  personFee: number;
  chargeMonthlyFee: boolean;
  chargePersonFee: boolean;
  name: string;
}

export interface TestSubscriptionPeriodInterface {
  isCurrent: boolean;
  startDate: string;
  endDate: string;
  isTrial: boolean;
  testSubscriptionPlan: TestSubscriptionPlanInterface;
}

export interface TestInvoiceFactoryRequestInterface {
  includeStateTaxList: boolean;
  testInvoiceRequest: TestInvoiceRequestInterface;
  salesTaxSeedList: Array<SalesTaxSeedInterface>;
  stateSeedList: Array<StateSeedInterface>;
}

export interface TestInvoiceFactoryResponseInterface {
  debugLogs: Array<string>;
  testCustomerInvoiceList: Array<TestCustomerInvoiceInterface>;
  testStateTaxList: Array<TestStateTaxInterface>;
  validationResults: ValidationResultsInterface;
}

export interface AdjustmentInterface {
  amount: number;
  memo: string;
  isCharge: boolean;
  isCredit: boolean;
}

export interface TestNsfActivityInterface {
  fee: number;
  activityDate: string;
  memo: string;
}

export interface TestRejectedActivityInterface {
  fee: number;
  activityDate: string;
  memo: string;
}

export interface TestCustomerInvoiceInterface {
  billingStart: string;
  billingEnd: string;
  amount: number;
  documentId?: number;
  dueOn: string;
  planName: string;
  invoiceStatusType: string;
  invoiceType: string;
  invoiceFeeType: string;
  testInvoiceItemList: Array<TestInvoiceItemInterface>;
}

export interface TestInvoiceItemInterface {
  description: string;
  amount: number;
  memo: string;
  invoiceItemType: string;
  initialAmount: number;
  discountAmount: number;
  discountPercent: number;
  isClientNsf: boolean;
}

export interface TestStateTaxInterface {
  stateId?: number;
  stateName: string;
  salesTaxPercent: number;
}

export interface TestPartnerInvoiceFactoryRequestInterface {
  includeStateTaxList: boolean;
  testPartnerInvoiceRequest: TestPartnerInvoiceRequestInterface;
  salesTaxSeedList: Array<SalesTaxSeedInterface>;
  stateSeedList: Array<StateSeedInterface>;
}

export interface TestPartnerInvoiceFactoryResponseInterface {
  debugLogs: Array<string>;
  testStateTaxList: Array<TestStateTaxInterface>;
  testPartnerInvoiceList: Array<TestPartnerInvoiceInterface>;
  validationResults: ValidationResultsInterface;
}

export interface TestPartnerInvoiceInterface {
  billingStart: string;
  billingEnd: string;
  amount: number;
  documentId?: number;
  dueOn: string;
  invoiceStatusType: string;
  invoiceType: string;
  invoiceFeeType: string;
  testPartnerInvoiceItemList: Array<TestPartnerInvoiceItemInterface>;
}

export interface TestPartnerInvoiceRequestInterface {
  startDate: string;
  endDate: string;
  companyName: string;
  state: string;
  customDiscountPercent?: number;
  testInvoiceRequestList: Array<TestInvoiceRequestInterface>;
  testPartnerDiscountTierList: Array<TestPartnerDiscountTierInterface>;
}

export interface TestPartnerDiscountTierInterface {
  clientCountFrom: number;
  clientCountTo: number;
  discountPercent: number;
  tierNumber: number;
}

export interface StateSeedInterface {
  id: number;
  name: string;
  shortName: string;
}

export interface SalesTaxSeedInterface {
  id: number;
  stateId: number;
  taxPercentage: number;
  effectiveFrom: string;
  effectiveTo: string;
  salesTaxType: SalesTaxTypeEnum;
  accountId: number;
  name: string;
}

export interface TestPartnerInvoiceItemInterface {
  id: number;
  clientName: string;
  planName: string;
  baseFee: number;
  perPersonFee: number;
  numberOfPeople: number;
  subtotal: number;
  discounts: number;
  gstHst: number;
  pstQst: number;
  total: number;
  nsfFee: number;
  documentId: number;
  subscriptionPeriodId: number;
}

export interface CreditAndChargeInterface {
  id: number;
  isChrage: boolean;
  isCredit: boolean;
  amount: number;
  outstandingAmount: number;
  memo: string;
  internalNotes: string;
  invoiceContainer: InvoiceContainerInterface;
}

export interface CloseAccountBringHereReasonInterface {
  id: number;
  name: string;
}

export interface AccountStatusCardInterface {
  accountStatusType: AccountStatusEnum;
  overviewContainer: OverviewContainerInterface;
}

export interface CloseAccountStopReasonInterface {
  id: number;
  name: string;
}

export interface CloseAccountSuggestionInterface {
  id: number;
  name: string;
}

export interface PersistCustomDiscountRequestInterface {
  companyId: number;
  customDiscountPercent: number;
  revertToDefault: boolean;
}

export interface PersistCustomDiscountResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface SkipTrialRequestInterface {
  companyId: number;
}

export interface SkipTrialResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface TrialManipulatorRequestInterface {
  companyId: number;
  dateTrialEnds: string;
}

export interface TrialManipulatorResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface MaintainClientPartnerInvitationRequestInterface {
  accept: boolean;
  decline: boolean;
  partnerSecurityRoleType: SecurityRoleTypeEnum;
  clientCompanyId?: number;
  partnerCompanyId?: number;
  invitationId?: number;
  partnerPaysFees: boolean;
}

export interface MaintainClientPartnerInvitationResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface SetupMigratedCompanyBillingRequestInterface {
  companyId: number;
}

export interface SetupMigratedCompanyBillingResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface UnlockNsfCompanyBillingRequestInterface {
  companyId: number;
}

export interface UnlockNsfCompanyBillingResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetSubscriptionInvoiceListRequestInterface {
  companyId: number;
}

export interface GetSubscriptionInvoiceListResponseInterface {
  invoiceDetailsList: Array<InvoiceDetailsInterface>;
  validationResults: ValidationResultsInterface;
}

export interface InvoiceDetailsInterface {
  invoiceId: number;
  startDate?: string;
  endDate?: string;
  dueDate?: string;
  invoiceDate?: string;
}

export interface ProcessOracleWorkflowRequestInterface {
  workflowInstanceKey: string;
}

export interface ProcessOracleWorkflowResponseInterface {
  workflowResponse: WorkflowResponseInterface;
  validationResults: ValidationResultsInterface;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

import { Post } from '../../../httpClient';

export class BillingAccessService {
  getOverview(request: GetOverviewRequestInterface): Promise<GetOverviewResponseInterface> {
    return Post('/FinanceBillingAccess/getOverview', request);
  }

  getSubscriptionPlanList(
    request: GetSubscriptionPlanListRequestInterface
  ): Promise<GetSubscriptionPlanListResponseInterface> {
    return Post('/FinanceBillingAccess/getSubscriptionPlanList', request);
  }

  getInvoiceList(request: GetInvoiceListRequestInterface): Promise<GetInvoiceListResponseInterface> {
    return Post('/FinanceBillingAccess/getInvoiceList', request);
  }

  executeAction(request: ExecuteActionRequestInterface): Promise<ExecuteActionResponseInterface> {
    return Post('/FinanceBillingAccess/executeAction', request);
  }

  getCompanyList(request: GetCompanyListRequestInterface): Promise<GetCompanyListResponseInterface> {
    return Post('/FinanceBillingAccess/getCompanyList', request);
  }

  getCompanyOverview(request: GetCompanyOverviewRequestInterface): Promise<GetCompanyOverviewResponseInterface> {
    return Post('/FinanceBillingAccess/getCompanyOverview', request);
  }

  getSubscriptionHistory(
    request: GetSubscriptionHistoryRequestInterface
  ): Promise<GetSubscriptionHistoryResponseInterface> {
    return Post('/FinanceBillingAccess/getSubscriptionHistory', request);
  }

  getBillAdjustmentList(
    request: GetBillAdjustmentListRequestInterface
  ): Promise<GetBillAdjustmentListResponseInterface> {
    return Post('/FinanceBillingAccess/getBillAdjustmentList', request);
  }

  processWorkflow(request: ProcessWorkflowRequestInterface): Promise<ProcessWorkflowResponseInterface> {
    return Post('/FinanceBillingAccess/processWorkflow', request);
  }

  getCloseAccountData(request: GetCloseAccountDataRequestInterface): Promise<GetCloseAccountDataResponseInterface> {
    return Post('/FinanceBillingAccess/getCloseAccountData', request);
  }

  testInvoiceFactory(request: TestInvoiceFactoryRequestInterface): Promise<TestInvoiceFactoryResponseInterface> {
    return Post('/FinanceBillingAccess/testInvoiceFactory', request);
  }

  testPartnerInvoiceFactory(
    request: TestPartnerInvoiceFactoryRequestInterface
  ): Promise<TestPartnerInvoiceFactoryResponseInterface> {
    return Post('/FinanceBillingAccess/testPartnerInvoiceFactory', request);
  }

  persistCustomDiscount(
    request: PersistCustomDiscountRequestInterface
  ): Promise<PersistCustomDiscountResponseInterface> {
    return Post('/FinanceBillingAccess/persistCustomDiscount', request);
  }

  skipTrial(request: SkipTrialRequestInterface): Promise<SkipTrialResponseInterface> {
    return Post('/FinanceBillingAccess/skipTrial', request);
  }

  trialManipulator(request: TrialManipulatorRequestInterface): Promise<TrialManipulatorResponseInterface> {
    return Post('/FinanceBillingAccess/trialManipulator', request);
  }

  maintainClientPartnerInvitation(
    request: MaintainClientPartnerInvitationRequestInterface
  ): Promise<MaintainClientPartnerInvitationResponseInterface> {
    return Post('/FinanceBillingAccess/maintainClientPartnerInvitation', request);
  }

  setupMigratedCompanyBilling(
    request: SetupMigratedCompanyBillingRequestInterface
  ): Promise<SetupMigratedCompanyBillingResponseInterface> {
    return Post('/FinanceBillingAccess/setupMigratedCompanyBilling', request);
  }

  unlockNsfCompanyBilling(
    request: UnlockNsfCompanyBillingRequestInterface
  ): Promise<UnlockNsfCompanyBillingResponseInterface> {
    return Post('/FinanceBillingAccess/unlockNsfCompanyBilling', request);
  }

  getSubscriptionInvoiceList(
    request: GetSubscriptionInvoiceListRequestInterface
  ): Promise<GetSubscriptionInvoiceListResponseInterface> {
    return Post('/FinanceBillingAccess/getSubscriptionInvoiceList', request);
  }

  processOracleWorkflow(
    request: ProcessOracleWorkflowRequestInterface
  ): Promise<ProcessOracleWorkflowResponseInterface> {
    return Post('/FinanceBillingAccess/processOracleWorkflow', request);
  }
}

export default new BillingAccessService();
